import React, { useEffect, useRef, useState } from "react";
import "./HomeWork.css";
import SubjBoxProps from "./Subj_Box/SubjBoxProps";
import { Popup } from "semantic-ui-react";
import FilterBox from "../PreRead/Filter_Box/FilterBox";
import Pending from "./Pending/Pending";
import Completed from "./Completed/Completed";
import OnReview from "./OnReview/OnReview";
import SortedBy from "../PreRead/Filter_Box/SortedBy";
import "intro.js/introjs.css";
import { Steps } from "intro.js-react";
import HWTour from "../../SidebarHeader/Header/HWTour";

export default function HomeWorkMain({ type }) {
  const subMenu = localStorage.getItem("hwSubMenu")
  const popupRef = useRef(null);
  const [homeMain, setHomeMain] = useState({
    subMenu: subMenu || "pending",
    homeworkData: null,
  });
  const [stepsEnabled, setStepsEnabled] = useState(false);
  const [initialStep, setInitialStep] = useState(0);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [homeScreenWalkThroughPopup, setHomeScreenWalkThroughPopup] = useState(false);


  useEffect(() => {
    // Check if the popup has been shown before
    const hasShownPopup = localStorage.getItem("hasShownPopupHW");
    if (!hasShownPopup) {
      setHomeScreenWalkThroughPopup(true);
      localStorage.setItem("hasShownPopupHW", "true");
    }
  }, []);
  const [steps, setSteps] = useState([
    {
      element: ".FoterDetailContainer",
      intro: `
        <h3>Parent Features Bottom Pane</h3>
        <p>These are 4 Parents, each Parent has multiple features listed on the left most pane. Currently 'Homework' parent is selected.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".homeWork",
      intro: `
        <h3>Smart.Homework</h3>
        <p>Smart.Homework has 4 features (as shown in left most pane):
       </p>
       <ol>
          <li>Homework</li>
          <li>Pre-Read</li>
          <li>Activity</li>
        </ol>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".featuredLeftPaneHWM",
      intro: `
        <h3>Features Group Left Pane
        Smart.Homework has 3 features as shown:</h3>
        <ol>
        <li>Homework</li>
        <li>Pre-Read</li>
        <li>Activity</li>
        </ol>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".hw",
      intro: `
        <h3>Homework</h3>
        <p>Currently 'Homework' feature is selected, Let's navigate through this feature</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },

    {
      element: ".subWiseHW ",
      intro: `
        <h3>Subject Wise Home Work</h3>
        <p>You can see subject wise homework count for 'pending', 'review' and 'completed'</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".CardsHW  ",
      intro: `
        <h3>Cards Section</h3>
        <p>You can open homework from this section.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".pendingHW",
      intro: `
        <h3>Pending</h3>
        <p>In this tab you will find Homeworks which needs to be submitted by you.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".reviewHW",
      intro: `
        <h3>On Review</h3>
        <p>You will find your submitted homeworks which are yet to be reviewed by teacher.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".completedHW",
      intro: `
        <h3>Completed</h3>
        <p>You will find your submitted homeworkds which are reviewed by teacher.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },

    {
      element: ".filterHW",
      intro: `
        <h3>Filter</h3>
        <p>Using filter button you can filter items by subject time and date wise.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".sortByHW",
      intro: `
        <h3>Sort By</h3>
        <p>Using Sort by Button you can sort items in ascending or descending based on date.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".prifilePic",
      intro: `
        <h3>Your profile, B4S App layout</h3>
        <p>Access your profile Information.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".done",
      intro: `
        <h3>Awesome, you are done. 😊</h3>
        <p>Click anywhere on the screen or click on the cross icon.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
  ]);
  const onExit = () => {
    setStepsEnabled(false);
  };
  // const [ispopupopen, setIsPopupOpen] = useState(false);

  const [rotation, setRotation] = useState(0);
  const [isSortPop, setIsSortPop] = useState(false);

  const rotateImage = () => {
    setRotation((rotation) => rotation + 180);
  };

  const togglePopup = () => {
    setIsSortPop(!isSortPop);
  };

  const [filter, setFilter] = useState({
    subjectId: [],
    date: "",
    time: "",
    sortBy: -1,
    limit: 10,
    page: 1,
  });

  const toggleFilterPopup = () => {
    // setIsPopupOpen(!isPopupOpen);
    setIsPopupOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setIsPopupOpen(false);
      }
    };

    if (isPopupOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPopupOpen]);

  return (
    <div className="w-full relative">
      <Steps
        enabled={stepsEnabled}
        steps={steps}
        initialStep={initialStep}
        onExit={onExit}
      />

      <div className="text-2xl font-semibold text-blue-950">Subject-wise Homework</div>
      <div className="subjectBoxContainer mt-3 subWiseHW">
        <SubjBoxProps type="HW" />
      </div>
      {/*  */}
      <div className="homeWorkSubContainer">
        <div className="d-flex ">
          <div className="d-flex mt-3 col-3 gap-3 p-0 HomeWorkSubPartsMenuTotal">
            <div
              className={
                homeMain.subMenu === "pending"
                  ? "HomeWorkSubPartsMenuActive pendingHW"
                  : "HomeWorkSubPartsMenu pendingHW"
              }
              onClick={() => { setHomeMain({ subMenu: "pending" }); localStorage.setItem("hwSubMenu", "pending") }}
            >
              Pending
            </div>
            <div
              className={
                homeMain.subMenu === "review"
                  ? "HomeWorkSubPartsMenuActive  d-flex justify-content-center mr-2 reviewHW"
                  : "HomeWorkSubPartsMenu d-flex justify-content-center mr-2 reviewHW"
              }
              onClick={() => { setHomeMain({ subMenu: "review" }); localStorage.setItem("hwSubMenu", "review") }}
            >
              On Review
            </div>

            <div
              // className='HomeWorkSubPartsMenu d-flex justify-content-center'
              className={
                homeMain.subMenu === "Completed"
                  ? "HomeWorkSubPartsMenuActive d-flex justify-content-center completedHW"
                  : "HomeWorkSubPartsMenu d-flex justify-content-center completedHW"
              }
              onClick={() => { setHomeMain({ subMenu: "Completed" }); localStorage.setItem("hwSubMenu", "Completed") }}
            >
              Completed
            </div>
          </div>
          <div className="d-flex gap-4 align-items-center justify-content-end col-8 horizontalLine p-0 ">
            <div className="mb-3 filterHW">
              <div
                className="col-md-12 gap-2 filter_box"
                onClick={toggleFilterPopup}
              >
                <img
                  className="filter_icon"
                  src="/HwImg/filter Icon.svg"
                  alt=""
                />
                <span>Filter</span>
              </div>
              {/* <Popup
                on="click"
                className="popUpFilter_ass"
                open={isPopupOpen}
                onClose={togglePopup}
                onOpen={togglePopup}
                trigger={
                  <div
                    className="col-md-12 gap-2 filter_box"
                  // onClick={() => {
                  //   setIsPopupOpen(true);
                  // }}
                  >
                    <img
                      className="filter_icon"
                      src="/HwImg/filter Icon.svg"
                      alt=""
                    // onClick={() => {
                    //   setIsPopupOpen(true);
                    // }}
                    />
                    <span>Filter</span>
                  </div>
                }
                content={

                }
                position="bottom center"
              /> */}
            </div>
            <div
              className="d-flex gap-2 align-items-center  mb-3 sortByHW"
              style={{ cursor: "pointer" }}
              onClick={() => {
                togglePopup()
                rotateImage()
              }}
            >
              <div className="sortby">Sort by</div>
              <div>
                <img
                  src="/HwImg/DownArrowSort.png"
                  alt=""
                  style={{ transform: `rotate(${rotation}deg)` }}
                ></img>
              </div>
            </div>
            {/* <Popup
              on="click"
              className="popUpFilter_ass"
              trigger={

              }
              content={ }
              position="bottom center"
            /> */}
          </div>
        </div>

        <div className="orange-scrollBar"
          style={{ maxHeight: "40vh", overflowY: "scroll", paddingBottom: "10px" }}
        >
          {homeMain.subMenu === "pending" && (
            <Pending
              setFilter={setFilter}
              filter={filter}
              setHomeMain={setHomeMain}
            />
          )}
          {homeMain.subMenu === "Completed" && (
            <Completed
              setFilter={setFilter}
              filter={filter}
              setHomeMain={setHomeMain}
            />
          )}
          {homeMain.subMenu === "review" && (
            <OnReview
              setFilter={setFilter}
              filter={filter}
              setHomeMain={setHomeMain}
            />
          )}

          {homeScreenWalkThroughPopup && (
            <HWTour
              setHomeScreenWalkThroughPopup={setHomeScreenWalkThroughPopup}
              setStepsEnabled={setStepsEnabled}
            />
          )}
          {
            isPopupOpen && (
              <div ref={popupRef}>
                <FilterBox
                  setFilter={setFilter}
                  filter={filter}
                  setIsPopupOpen={setIsPopupOpen}
                  toggleFilterPopup={toggleFilterPopup}
                  type={type}
                />
              </div>
            )
          }
          {
            isSortPop && (
              <SortedBy filter={filter} setFilter={setFilter} type={type} togglePopup={togglePopup} />
            )
          }
        </div>
      </div>
    </div >
  );
}
